"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToMidnight = exports.overrideTZ = exports.sleep = exports.buildNow = exports.dateWeekBefore = void 0;
const moment_timezone_1 = __importStar(require("moment-timezone"));
const getEnv_1 = require("./getEnv");
function dateWeekBefore() {
    return (0, moment_timezone_1.default)().subtract(7, 'd').toISOString();
}
exports.dateWeekBefore = dateWeekBefore;
function buildNow(stubISOString, envVarName = 'STUB_TIME') {
    const envStubTime = (0, getEnv_1.getEnvValue)(envVarName, false);
    return () => {
        const stubTime = stubISOString || envStubTime;
        if (stubTime) {
            return (0, moment_timezone_1.default)(stubTime);
        }
        else {
            return (0, moment_timezone_1.default)();
        }
    };
}
exports.buildNow = buildNow;
function sleep({ hours = 0, minutes = 0, seconds = 0, milliseconds = 0 }) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            setTimeout(resolve, milliseconds + seconds * 1000 + minutes * 60 * 1000 + hours * 60 * 60 * 1000);
        });
    });
}
exports.sleep = sleep;
function overrideTZ(date, TZ = 'Europe/London') {
    const timeFormat = 'YYYY-MM-DDTHH:mm:ss';
    const time = moment_timezone_1.default.parseZone(date);
    return (0, moment_timezone_1.tz)(time.format(timeFormat), TZ);
}
exports.overrideTZ = overrideTZ;
function convertToMidnight(date) {
    return moment_timezone_1.default.utc(date).hours(0).minutes(0).seconds(0).milliseconds(0).toISOString();
}
exports.convertToMidnight = convertToMidnight;
